import { render } from "./MyProspectsList.vue?vue&type=template&id=78d04542"
import script from "./MyProspectsList.vue?vue&type=script&lang=ts"
export * from "./MyProspectsList.vue?vue&type=script&lang=ts"

import "./MyProspectsList.vue?vue&type=style&index=0&id=78d04542&lang=css"
script.render = render

export default script